import styled from '@emotion/styled';

export const StyledDiv = styled.div`
  width: 59.375rem;
  height: 32.875rem;
  @media (max-width: 64rem) {
    width: 80%;
  }
  @media (max-width: 48rem) {
    width: 100%;
    margin-top: 2rem;
  }
`;
